var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Attachments ")]),_c('div',[_c('FormulateInput',{ref:"file",staticClass:"w-full rounded-xl group cursor-pointer",attrs:{"type":"file","single":"","add-label":true,"disabled":_vm.disabled},on:{"input":_vm.handleFiles},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }